import { AdminFilterChips } from "@/components/admin";

const emergencyFilterChips = [
  { key: "all", label: "전체" },
  { key: "open", label: "미처리" },
  { key: "in-progress", label: "확인/처리 중" },
  { key: "resolved", label: "처리 완료" },
  { key: "sos", label: "긴급 호출" },
  { key: "no-response", label: "무응답" },
  { key: "risk-sound", label: "소리/위험" },
];

interface QuickFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const QuickFilters = ({ activeFilter, onFilterChange }: QuickFiltersProps) => {
  return <AdminFilterChips chips={emergencyFilterChips} activeKey={activeFilter} onChange={onFilterChange} />;
};

export default QuickFilters;
